<template>
    <b-modal
        v-model="openModal"
        :title="`Enviar Nueva Contraseña al usuario: ${user.nombre}`"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        size="lg">
        <p class="mt-2">Desea enviar una nueva contraseña a: <b>{{user.nombre}}</b> al correo: <b>{{user.email}}</b></p>
        <template v-slot:modal-footer>
            <b-button variant="danger"
                @click.prevent="$emit('close-modal')">
                Cancelar
            </b-button>
            <b-button variant="success"
                @click.prevent="sendNewPassswordToUser" >
                Enviar
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'passwordReset',
    props: {
        openModal: {
            type: Boolean
        },
        user: {
            type: Object
        }
    },
    data(){
        return{
            modalConfirmResetPassword: false,
            UsersLists: [],
            response: "",
        }
    },

    methods:{
        ...mapMutations(['setLoading']),
        async sendNewPassswordToUser(){
            this.setLoading(true)
            this.$emit('close-modal')
            await this.$conectar.post('/admin/empresas/users/send-new-password-to-user', {id: this.user.id})
            .then(response =>{
                this.$bvToast.toast(response.data.mensaje, {
                    title: "Respuesta del servidor",
                    variant: "success",
                    solid: true
                })
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        }
    }
}

</script>
